import {ajax_post} from "./index";
export const savaScore = (data) => ajax_post('/museumscoresave', data);
export const savaSuggest = (data) => ajax_post('/proposalsave', data);
export const savaScorenew = (data) => ajax_post('/scoreadjustcalculate', data);
